import React, { useEffect, useState } from "react"
import "./introHotel.scss"
import { Container, Row, Col } from "react-bootstrap"
import { useIntl } from "gatsby-plugin-react-intl"
import { debounce } from "../../functions"
import Marquee from "react-fast-marquee"
import { graphql } from "gatsby"
import Heading from "../heading"
import HTMLReactParser from "html-react-parser"
import { GatsbyImage, getImage, getSrc } from "gatsby-plugin-image"
import CtaIntroHotel from "./ctaIntroHotel"

const IntroHotel = ({ hotelId, content }) => {
  const intl = useIntl()

  const breakpoint = 1024

  const [screen, setMobile] = useState({
    isMobile: typeof window !== `undefined` && window.innerWidth < breakpoint,
  })

  const [isClient, setClient] = useState(false)

  useEffect(() => {
    setClient(true)

    const debouncedHandleResize = debounce(function handleResize() {
      setMobile({
        isMobile:
          typeof window !== `undefined` && window.innerWidth < breakpoint,
      })
    }, 200)

    if (typeof window !== `undefined`) {
      window.addEventListener("resize", debouncedHandleResize)
    }
  }, [])

  const removeIllustration = (arr, index) => {
    return arr.filter((_, i) => i !== index)
  }

  return (
    <section className="blkHotel-intro container-fluid">
      <Container>
        <Row>
          <Col md={8} xs={12}>
            <div>
              {content.introduction_v2_caption && (
                <span className="caption animTxt">
                  <span>{content.introduction_v2_caption}</span>
                </span>
              )}
              {content.introduction_v2_stars && (
                <div className="hotelRatings">
                  {[...Array(content.introduction_v2_stars)].map((e, i) => (
                    <i key={i} className="icon-star4"></i>
                  ))}
                </div>
              )}
            </div>
            <Heading
              title={content.introduction_v2_title}
              description={HTMLReactParser(
                content.introduction_v2_description.processed
              )}
            />
          </Col>
        </Row>
      </Container>
      {isClient && screen.isMobile
        ? content.relationships.introduction_v2_medias.length > 0 && (
            <div
              className="HotelMobileGallery"
              style={{
                backgroundImage:
                  content.relationships.introduction_v2_medias.length > 1
                    ? "url(" +
                      getSrc(content.relationships.introduction_v2_medias[2].relationships.field_image.gatsbyImage)
                    : "" + ")",
              }}
            >
              <Marquee gradient={false} speed={100}>
                {removeIllustration(
                  content.relationships.introduction_v2_medias,
                  2
                ).map((media, index) => (
                  <GatsbyImage
                    key={index}
                    image={getImage(media.relationships.field_image.gatsbyImage)}
                    alt={media.field_image.alt}
                  />
                ))}
              </Marquee>
            </div>
          )
        : content.relationships.introduction_v2_medias.length === 6 && (
            <div className="hotelGallery">
              <div className="hotelGrid img0">
                <GatsbyImage
                  image={getImage(
                    content.relationships.introduction_v2_medias[0]
                      .relationships.field_image.gatsbyImage
                  )}
                  alt={
                    content.relationships.introduction_v2_medias[0].field_image
                      .alt
                  }
                />
              </div>
              <div className="hotelGrid img1">
                <GatsbyImage
                  image={getImage(
                    content.relationships.introduction_v2_medias[1]
                      .relationships.field_image.gatsbyImage
                  )}
                  alt={
                    content.relationships.introduction_v2_medias[1].field_image
                      .alt
                  }
                />
              </div>
              <div className="hotelGridCol">
                <div className="hotelGrid img2">
                  <GatsbyImage
                    image={getImage(
                      content.relationships.introduction_v2_medias[2]
                        .relationships.field_image.gatsbyImage
                    )}
                    alt={
                      content.relationships.introduction_v2_medias[2]
                        .field_image.alt
                    }
                  />
                </div>
                <div className="hotelGrid img3">
                  <GatsbyImage
                    image={getImage(
                      content.relationships.introduction_v2_medias[3]
                        .relationships.field_image.gatsbyImage
                    )}
                    alt={
                      content.relationships.introduction_v2_medias[3]
                        .field_image.alt
                    }
                  />
                </div>
              </div>
              <div className="hotelGrid img4">
                <GatsbyImage
                  image={getImage(
                    content.relationships.introduction_v2_medias[4]
                      .relationships.field_image.gatsbyImage
                  )}
                  alt={
                    content.relationships.introduction_v2_medias[4].field_image
                      .alt
                  }
                />
              </div>
              <div className="hotelGrid img5">
                <GatsbyImage
                  image={getImage(
                    content.relationships.introduction_v2_medias[5]
                      .relationships.field_image.gatsbyImage
                  )}
                  alt={
                    content.relationships.introduction_v2_medias[5].field_image
                      .alt
                  }
                />
              </div>
            </div>
          )}
      <Container className="hotelGalleryDesc">
        <Row>
          <Col md={8} xs={12}>
            {content.introduction_v2_additional_desc1 && (
              <div className="description animTxt animTxt_3">
                {HTMLReactParser(
                  content.introduction_v2_additional_desc1.processed
                )}
              </div>
            )}
          </Col>
        </Row>
        <Row>
          <Col>
                  <CtaIntroHotel items={content.relationships.introduction_v2_items} />
            {/* <div className="hotelGalleryLinks">
              <a href="#" className="simpleLink">
                Video 360
              </a>
              <a href="#" className="simpleLink">
                Fiche technique
              </a>
              <a href="#" className="simpleLink">
                Expérience a day at VPV
              </a>
            </div> */}
          </Col>
        </Row>
        <Row>
          {content.introduction_v2_additional_desc2 &&
            HTMLReactParser(content.introduction_v2_additional_desc2.processed)}
        </Row>
      </Container>
    </section>
  )
}

export const query = graphql`
  fragment introHotel on paragraph__introduction_v2 {
    introduction_v2_title
    introduction_v2_stars
    introduction_v2_description {
      processed
    }
    introduction_v2_caption
    introduction_v2_additional_desc2 {
      processed
    }
    introduction_v2_additional_desc1 {
      processed
    }
    relationships {
      introduction_v2_items {
        ... on paragraph__link_item {
          internal {
            type
          }
          link_item_link {
            title
            url
          }
        }
        ... on paragraph__file_item {
          internal {
            type
          }
          file_item_title
          relationships {
            file_item_media {
              relationships {
                field_media_file {
                  url
                }
              }
            }
          }
        }
        ... on paragraph__remote_video_item {
          internal {
            type
          }
          remote_video_item_title
          relationships {
            remote_video_item_media {
              field_media_oembed_video
            }
          }
        }
      }
      introduction_v2_medias {
        field_image {
          alt
        }
        relationships {
          ...getImage
        }
      }
    }
  }
`

export default IntroHotel
